import { DateType } from "~/patients";

export const formatDateAnswers = (answer: DateType[]) =>
  answer.map((val) => new Date(val.date).toLocaleDateString());
